import { Component, OnInit, ElementRef, ViewChild, TemplateRef, Renderer2, ViewChildren, QueryList } from '@angular/core';
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { IUserDetails } from '../../../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../../shared/providers/validation.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { IAddStandardUserModel } from '../../../shared/models/AddStandardUserModel';
import { IStandardUserProperties } from '../../../shared/models/StandardUserProperties';
import { LoaderService } from '../../../shared/providers/loader.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { IUserInput } from '../../../shared/models/UserInputModel';
import { ToastService } from '../../../shared/providers/toast.service';
import { IUserCreationResponseModel } from '../../../shared/models/UserCreationResponseModel';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';

enum Tab {
  PersonalInformation = 1,
  ActivityLog = 2
}

@Component({
  selector: 'standarduser-details',
  templateUrl: './standarduser-details.component.html',

})

export class StandardUserDetailsComponent {

  userDetailsOutput = {} as IUserDetails;
  properties: Array<IStandardUserProperties> = [];
  userGuid: string = "";
  isViewAuditTrail = false;
  auditObjectId = 0;
  auditObjectTypeId = 0;
  viewOrHideLabel = "View";
  prevPage = "StandardUser";
  prevPageRouteLink = "users/employees";
  PrincipalUserGuid: string = '0000';
  propertyIds: number[] = [];
  //defaultContactText: IMultiSelectTexts = {
  //  defaultTitle: 'Select property',
  //  checkAll: 'Select all',
  //  uncheckAll: 'Unselect all',

  //};
  userInputModel = {} as IUserInput;
  propertyList = [];
  propertyIdsToAdd = [];
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Property",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,


  };
  IsEditMode: boolean = true;
  addUserForm: FormGroup;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  loggedUserDetails: any;
  @ViewChild('addstandarduser') accept: TemplateRef<null>;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;

  constructor(private _userManagerService: UserManagerService, private renderer: Renderer2,
              private activatedRoute: ActivatedRoute, public authService: AuthenticationService, private router: Router, public _validationService: ValidationService, protected loaderService: LoaderService, private modalService: BsModalService, private _propertyManagementService: PropertyManagementService, private _toastService: ToastService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userGuid = params['user'];
      if (params['PrincipalUserGuid'] != '' && params['PrincipalUserGuid'] != null && params['PrincipalUserGuid'] != undefined) {
        this.PrincipalUserGuid = params['PrincipalUserGuid'];
      }
      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
    });
  }
  User: any;

  ngOnInit() {
    this.loaderService.display(true);
    this.addUserForm = new FormGroup({
      'txtFirstName': new FormControl(this.userInputModel.FirstName),
      'txtLastName': new FormControl(this.userInputModel.LastName),
      'txtEmail': new FormControl(this.userInputModel.EmailAddress),
      'txtPhone': new FormControl(this.userInputModel.PhoneNumber),
      'lstRole': new FormControl(this.propertyIdsToAdd, [
        Validators.required
      ])
    });
    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;
      }
    });
    this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
      this.userInputModel.UserGuid = this.userGuid;
      this.userInputModel.FirstName = response.FirstName;
      this.userInputModel.LastName = response.LastName;
      this.userInputModel.EmailAddress = response.Email;
      this.userInputModel.PhoneNumber = response.Phoneno;
      this.userInputModel.Address1 = response.Address1;
      this.userInputModel.Address2 = response.Address2;
      this.userInputModel.StateId = response.StateId;
      this.userInputModel.CityId = response.CityId == null ? 0 : response.CityId;
      this.userInputModel.Zip = response.Zip;
      this.userInputModel.UserRoleId = response.UserRoleId;
      this.userInputModel.UserStatus = response.UserStatusId;
      this.userInputModel.ProfilePicPath = response.ProfilePicPath;
      this.userInputModel.IsAvailablePropertyAccessEnabled = response.IsAvailablePropertyAccessEnabled;
      this.userInputModel.IsOffMarketPropertyAccessEnabled = response.IsOffMarketPropertyAccessEnabled;
      this.userInputModel.IsMyPortfolioEnabled = response.IsMyPortfolioEnabled;
      this.userInputModel.IsOn1031Exchange = response.IsOn1031Exchange;
      this.userInputModel.UserRoleIdList = response.UserRoleIdList;
      this.userInputModel.Is1031User = response.Is1031User;

      this.userInputModel.Password = '***********************************************************************';

      this.userInputModel.CompanyName = response.CompanyName;
      this.userDetailsOutput = response;
      this.auditObjectId = this.userDetailsOutput.Id;
      this.auditObjectTypeId = 301;
      const user =
      {
        Id: response.Id,
        Name: response.FirstName + " " + response.LastName,
        Role: response.UserRoleId,
      }
      this.User = user;
      this.loaderService.display(false);

      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }

      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }

      this._userManagerService.GetStandardUserProperties(user.Id, this.PrincipalUserGuid).subscribe(res => {
        this.properties = res.data ? res.data : [];
        this.properties.forEach(response => {
          this.propertyIds.push(response.PropertyId);
          this.propertyIdsToAdd.push(response.PropertyId);
        });
      });
    });
    this.getProperties();
  }

  get txtFirstName() { return this.addUserForm.get('txtFirstName'); }
  get txtLastName() { return this.addUserForm.get('txtLastName'); }
  get txtEmail() { return this.addUserForm.get('txtEmail'); }
  get txtPhone() { return this.addUserForm.get('txtPhone'); }

  tab = Tab;
  activeTab = Tab.PersonalInformation;
  onTabClick(selectedTab) {
    this.activeTab = selectedTab;
    if (this.activeTab === Tab.ActivityLog) {

    }
  }
  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }
  //editUser() {
  //  this.router.navigate(['/standarduser-add'], { queryParams: { PrincipalUserGuid: this.PrincipalUserGuid, user: this.userGuid } });
  //}

  modalRef: BsModalRef;
  editUser(template: TemplateRef<any>, classes: any) {
    this.openModal(this.accept, 'portfolio-bov-modal')

    //this.modalRef = this.modalService.show(template, { class: classes });

    /* this.router.navigate(['/standarduser-add'], { queryParams: { PrincipalUserGuid: this.UserGuid } });*/
  }

  openModal(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  getProperties() {
    let principalId = this.userGuid != null && this.userGuid != '' ? this.userGuid : '0000';
    this._propertyManagementService.getPrincipalPortfolioProperties(this.loggedUserDetails.Id, this.PrincipalUserGuid, principalId).subscribe(response => {
      if (response != null && response.length > 0) {
        this.properties = response;
        this.propertyList = response.map(o => {
          return { id: o.Id, name: o.DisplayName + o.Address };
        });
      }
    });
  }

  onClose() {
    this.modalRef.hide();
  }

  addPropertyValidation: string = "";
  saveUser() {
    this.userInputModel.IsStandardUser = true;
    let IsValid: boolean = true;
    if (this.propertyIdsToAdd.length <= 0) {
      IsValid = false;
      this.addPropertyValidation = "Select at least one property."
    }
    else {
      this.addPropertyValidation = "";
    }

    if (IsValid) {
      if (this.userInputModel.EmailAddress) {
        this.userInputModel.DataEntryPropertyIds = []
        this.propertyIdsToAdd.forEach(s => {
          this.userInputModel.DataEntryPropertyIds.push(s);
        });


        this.loaderService.display(true)
        this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
          this.userCreationResponseModel = response;
          this.loaderService.display(false)
          if (this.userCreationResponseModel.Success == true) {
            this._userManagerService.GetStandardUserProperties(this.User.Id, this.PrincipalUserGuid).subscribe(res => {
              this.properties = res.data ? res.data : [];
            });
            this._toastService.addToast({ title: 'Success', msg: 'User Details Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
            this.modalRef.hide();
          }
          else {
            this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
        });
      }
    }
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  viewAuditTrail() {
    if (this.isViewAuditTrail == false) {
      this.isViewAuditTrail = true;
      this.viewOrHideLabel = "Hide";
    }
    else {
      this.isViewAuditTrail = false;
      this.viewOrHideLabel = "View";
    }
  }

  selectAllProperty() {
    this.propertyIdsToAdd = this.propertyList.map((property) => property.id);
  }

  unselectAllProperty() {
    this.propertyIdsToAdd = [];
  }

  get lstRole() {
    return this.addUserForm.get('lstRole');
  }
}
